import styles from "./EmptyHeader.module.scss";
import { HomeLink } from "@/components/home-link/HomeLink";
import type { FC } from "react";
import { useRouter } from "next/router";

export const TV_HUB_HOME = "https://tv.onefootball.com";

export const EmptyHeader: FC = () => {
  const { locale } = useRouter();
  return (
    <header className={styles.EmptyHeader}>
      <div className={styles.mainMenu}>
        <HomeLink
          isClientSide={false}
          href={`${TV_HUB_HOME}/${locale ?? "en"}`}
        ></HomeLink>
      </div>
    </header>
  );
};
